'use client';

import { ContactsRuDesktop } from './ContactsRuDesktop';
import { ContactsRuMobile } from './ContactsRuMobile';

import { TranslatedComponent } from '@/shared/types';

export const ContactsRu = ({ translations }: TranslatedComponent) => {
  return (
    <>
      {/* Мобильная версия */}
      <div className="md:hidden">
        <ContactsRuMobile translations={translations} />
      </div>

      {/* Десктопная версия */}
      <div className="max-md:hidden">
        <ContactsRuDesktop translations={translations} />
      </div>
    </>
  );
};
